import { FONT_TITLE, FONT_COLOUR_SCORE, FONT_COLOUR_SCORE_TARGET } from 'app/constants/AppConstants';
import { createTextField } from 'utils/Text';
import { zeroPad } from 'utils/utils';

export default class TimeDisplay extends Phaser.Group {
  constructor({ game, score = 0, target = 100 }) {
    super(game);

    // add paper icon
    this.icon = this.game.make.sprite(0, 0, 'ui', 'icon_clock');
    this.icon.x = 0;
    this.icon.y = 0;
    this.add(this.icon);

    // // add main score
    this.timeDisplay = createTextField(this.game, FONT_TITLE, 150, FONT_COLOUR_SCORE);
    this.timeDisplay.y = this.icon.height * 0.5 - 100;
    this.timeDisplay.x = this.icon.width + 20;
    this.timeDisplay.text = score;
    this.add(this.timeDisplay);

    this.setTime(0);
  }

  /*
  ============================================================================================
    GETTERS
  ============================================================================================
  */

  get width() {
    return this.timeDisplay.x + this.timeDisplay.width;
  }
  get height() {
    return this.timeDisplay.height;
  }

  /*
  ============================================================================================
    SETTER
  ============================================================================================
  */

  setTime(milliseconds) {
    const minutes = Math.floor(milliseconds / 60000);
    const seconds = ((milliseconds % 60000) / 1000).toFixed(0);
    this.timeDisplay.text = zeroPad(minutes, 2) + ':' + zeroPad(seconds, 2);
  }

  /*
  ============================================================================================
    TOODLES
  ============================================================================================
  */

  destroy() {
    // destroy stuff - it's therapudic
    this.icon.destroy(true);
    this.timeDisplay.destroy(true);
    // nullify it - GC flag :)
    this.icon = null;
    this.timeDisplay = null;
    // super!!!!!
    super.destroy(true);
  }
}
